import { render, staticRenderFns } from "./AiScoreViewDetail.vue?vue&type=template&id=38a6a04a&scoped=true"
import script from "./AiScoreViewDetail.vue?vue&type=script&lang=js"
export * from "./AiScoreViewDetail.vue?vue&type=script&lang=js"
import style0 from "./AiScoreViewDetail.vue?vue&type=style&index=0&id=38a6a04a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a6a04a",
  null
  
)

export default component.exports